$(document).on("scroll", function () {
  const target = $(".bookingCompanion");
  if (target.length === 0) return;

  target.toggleClass(
    "fixed",
    $(document).scrollTop() >= $(".menu").outerHeight(),
  );
  target.toggleClass(
    "fixedBottom",
    $(document).scrollTop() >=
      $(".scrollArea").offset().top +
        $(".scrollArea").outerHeight() -
        target.outerHeight(),
  );
});
